/**
 * True when extracted role is safe to show in UI and to interpret as a real role for scoring labels.
 * Filters out empty, "undefined", and "null" string artifacts from APIs/JSON.
 */
export function isUsableExtractedRole(role: unknown): boolean {
  if (role == null) return false;
  const t = String(role).trim();
  if (!t) return false;
  const lower = t.toLowerCase();
  if (lower === 'undefined' || lower === 'null') return false;
  return true;
}
